const feedback = {
  color: 'none',
  header: '',
  body: '',
  icon: null
};

export default function(state = feedback, action) {
  switch (action.type) {
    case 'New Feedback':
      console.log('newfeedback');
      return {
        ...state,
        color: action.payload.color,
        icon: action.payload.icon,
        header: action.payload.header,
        body: action.payload.body
      };
      break;
    case 'Kill Feedback':
      return {
        ...state,
        color: 'none'
      };

      break;
    default:
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/feedback-reducer.js